<div class="container">
  <div class="container-screen-content">
    <div class="divsearch-monitoring">
      <app-gate-monitoring-filter
        (filterType)="filterByArrival($event)"
      ></app-gate-monitoring-filter>
      <div class="gates-monitoring" *ngIf="!showHistory">
        <div
          class="gates-monitoring-container"
          *ngIf="arrivalMonitor.length > 0; else noArrivals"
        >
          <div
            class="gates-monitoring-card-item"
            *ngFor="let arrival of arrivalMonitor; index as i"
          >
            <app-card-arrival
              [gatesMonitor]="arrival"
              (clickToStatusDetail)="openStatusDetail($event)"
              (releaseChildByArrivalid)="releaseChild($event)"
            >
              ></app-card-arrival
            >
          </div>
        </div>
        <ng-template #noArrivals>
          <app-empty-list
            class="no-arrivals"
            [imagePath]="'../../../../../assets/images/no-arrival.svg'"
            [titleText]="'Tudo tranquilo por aqui!'"
            [articleText]="messagePage"
          ></app-empty-list>
        </ng-template>
      </div>
      <!-- componente de historico -->
      <app-history [gateId]="gateId" *ngIf="showHistory"></app-history>
    </div>
  </div>
</div>
